// extracted by mini-css-extract-plugin
module.exports = {"hero":"Donate-module--hero--mlL4q"};